import React from 'react';

import { PlayfulServiceHome } from 'themes/playful/components/services/PlayfulServiceHome';

import { useHomePage } from 'hooks/page/home/useHomePage';

import { ServiceOptionsModal } from 'routes/services/ServiceOptionsModal';

import { TService } from 'types/service';

import s1 from 'themes/playful/components/PlayfulLayout.module.css';

export const ServiceList = () => {
  const {
    services,
    onServiceClick,
    pendingSelectService,
    onSelectServiceOption,
    onCloseServiceOption,
  } = useHomePage();

  const serviceList = services.slice(0, 3);

  return (
    <>
      <div className={s1.content}>
        {serviceList.map((service: TService) => (
          <React.Fragment key={service.guid}>
            <PlayfulServiceHome service={service} onClick={onServiceClick} />
          </React.Fragment>
        ))}
      </div>
      <ServiceOptionsModal
        service={pendingSelectService}
        onSelect={onSelectServiceOption}
        onClose={onCloseServiceOption}
      />
    </>
  );
};
